import { ReactNode } from 'react'
import { Stack } from '@mui/material'
import TripBuilderAddButton from 'pages/trip/create-trip/trip-builder-selection/trip-builder-add-button'

type LoadConfirmationStopActionsProps = {
  hasTransportStops: boolean
  showEmptyState?: boolean
  onAddPickupDelivery: () => void
  onChangePickupDelivery: () => void
  children: ReactNode
}

export function LoadConfirmationStopActions({
  hasTransportStops,
  showEmptyState = false,
  onAddPickupDelivery,
  onChangePickupDelivery,
  children,
}: LoadConfirmationStopActionsProps) {
  if (!hasTransportStops && showEmptyState) {
    return (
      <Stack sx={{ p: 2 }}>
        <TripBuilderAddButton
          label="+ Add Pickup & Delivery"
          onClick={onAddPickupDelivery}
        />
      </Stack>
    )
  }

  if (!hasTransportStops) {
    return null
  }

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      <TripBuilderAddButton
        label="Change Pickup & Delivery"
        onClick={onChangePickupDelivery}
      />
      {children}
    </Stack>
  )
}
